import * as z from 'zod';
import { ErrorMessages } from './error-messages';

export const eventDetailsFormSchema = z.object({
  name: z
    .string()
    .nonempty(ErrorMessages.Required)
    //.min( 2, ErrorMessages.TOO_SHORT( 2 ) )
    .max(80, ErrorMessages.TOO_LONG(80)),
  description: z.string().max(5000, ErrorMessages.TOO_LONG(5000)),
  learningOutcomes: z
    .array(z.string())
    .min(1, 'At least one learning outcome is required'),
  isFundraiser: z.boolean().optional(),
  isMembersOnly: z.boolean().optional(),
  allowWalkInCheckIn: z.boolean().optional(),
  checkInStateOverride: z.enum(['auto', 'open', 'closed']).optional(),
});

export type EventDetailsForm = z.TypeOf<typeof eventDetailsFormSchema>;
